 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		20: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		20: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"0cbcc34d3992db1f1e9978a63f77b32dcd621e3e","2":"bc6035d46d23e0c06a88d56fa29fdfd7a70c7002","3":"c932766d22752000d29a29d23861cc8054401098","4":"455a435357834a04c481392675faa64f6a3b9def","5":"1bfc9850","6":"8870da3999d8eb29c75fcb7ecd61f169a530b4c2","7":"6cad00992574e4b4ecb79bb8db3cc49b1988bbbd","8":"14e68cb6bd6245bc062c636b270e29f1b65ed98c","9":"0c428ae2","10":"69cf29f6a642f418953be3f9f3f996ec8951e346","11":"e7baecb53e83f0d850c8b32fd82c1fc3811beb2d","12":"5f656039bfe7158df1011809f2a764d19aad7bce","13":"ad0fdebf47648f82048db7e5e5e5747c8188ac38","14":"50c5772473374fcd32a37fa3ce46f4808a925965","15":"89408303e9f5343d28e0baae1cbd2bfe8f866606","16":"fde2f15fc409f50db205465780643950249621e7","17":"37c513a04e2ce50c8086637e4b85d9a30e23a1b9","18":"400789b889322af0c58892d25b6fc35d6a17b3bd","19":"6fd3b0ff51b6814cd82eb1e7fdaf6b9a0a6006a4","21":"2c386607","23":"component---src-pages-404-jsx","24":"component---src-pages-about-us-jsx","25":"component---src-pages-billing-jsx","26":"component---src-pages-build-phases-jsx","27":"component---src-pages-build-process-jsx","28":"component---src-pages-case-study-jsx","29":"component---src-pages-contact-us-jsx","30":"component---src-pages-copyright-jsx","31":"component---src-pages-cost-to-make-an-app-[id]-jsx","32":"component---src-pages-cost-to-make-an-app-course-1-jsx","33":"component---src-pages-cost-to-make-an-app-course-2-jsx","34":"component---src-pages-cost-to-make-an-app-dev-steps-jsx","35":"component---src-pages-cost-to-make-an-app-direct-cost-jsx","36":"component---src-pages-cost-to-make-an-app-estimate-jsx","37":"component---src-pages-cost-to-make-an-app-estimation-jsx","38":"component---src-pages-cost-to-make-an-app-expert-consult-jsx","39":"component---src-pages-cost-to-make-an-app-index-jsx","40":"component---src-pages-cost-to-make-an-app-intro-jsx","41":"component---src-pages-cost-to-make-an-app-more-jsx","42":"component---src-pages-cost-to-make-an-app-new-thank-you-jsx","43":"component---src-pages-cost-to-make-an-app-patch-jsx","44":"component---src-pages-cost-to-make-an-app-platforms-jsx","45":"component---src-pages-cost-to-make-an-app-product-marketing-jsx","46":"component---src-pages-cost-to-make-an-app-samples-jsx","47":"component---src-pages-cost-to-make-an-app-sign-up-jsx","48":"component---src-pages-cost-to-make-an-app-testimonial-sign-up-jsx","49":"component---src-pages-cost-to-make-an-app-thank-you-jsx","50":"component---src-pages-cost-to-make-an-app-zero-jsx","51":"component---src-pages-funding-jsx","52":"component---src-pages-index-jsx","53":"component---src-pages-jobs-jsx","54":"component---src-pages-payments-jsx","55":"component---src-pages-privacy-policy-jsx","56":"component---src-pages-sample-apps-jsx","57":"component---src-pages-terms-of-service-jsx","58":"component---src-pages-testimonials-2-jsx","59":"component---src-pages-testimonials-jsx","60":"component---src-pages-thank-you-jsx","61":"component---src-pages-unsubscribe-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"eb089d821d5ab7abfed7","2":"d94ac74db4cdab6ee8be","3":"c7a88deda78ec4e07bd9","4":"9000bc0a64934146047f","5":"5bfad85a095921ca8497","6":"3899cb9590f0e0421a8b","7":"3e784557b878bf2bc02a","8":"66be0d952c9b0dfb2f8d","9":"06114fc94456155ae0f6","10":"d8b6cd18f4dcf38c356b","11":"9e25172c9385cbd23cbe","12":"6a3412f26d29ec6ec14f","13":"7de8b0b3ec436fde8ca4","14":"20e1005f30914f0ddb40","15":"2bfc6095613cf7118d76","16":"8360eedfb50a2b17d637","17":"2a5eaff07dafadebb9ab","18":"12e40c8a487304759085","19":"03788f403b2ef808fece","21":"ad2e67e89ce85b0fb763","23":"8f20dde576dbb3cd1590","24":"5bed889925746934443a","25":"878aa24ade54c8656169","26":"e61cf88e10c476d1cf4a","27":"7addb94540d2cffe1352","28":"18a39bd766b70bf2956b","29":"3c0145a29f0db3681c1c","30":"22348a3c572a8e3d35bc","31":"4f273de2b399cc3e3392","32":"1703b560063b59722925","33":"59bb5e1a7c67266bc3c5","34":"cd36e4e2e10353b2eca1","35":"92c3157a515336062359","36":"d8dae71b81a2a6a7a18a","37":"eff4875c05f8c259d3a2","38":"0bb763636faad5420de6","39":"6a568937e616cc0703e3","40":"8e24745aa44ab91a2b73","41":"9f22a1019513c84bed21","42":"861beb3dccc9e0a9258b","43":"adc269a709202a0d4e8b","44":"cce8cc983c849e8b80ec","45":"27141a67e5aa9a982254","46":"4ae25c7672f52b1c06de","47":"4d35b5681fa171def09d","48":"38710879d080a3978430","49":"91b2646c699514bd4a81","50":"2460b5ab0aae4d2721c5","51":"f7e2ee68e5d7cd8c9afb","52":"49124ae103e02fb89371","53":"d6dfe3ae5226d7350334","54":"d41ba2215ef3c1434388","55":"336f2ab9682e971e42ca","56":"a3bda884349ec5a374a7","57":"358d28ba89c23213c810","58":"7e6aee48e2b00ff81e13","59":"0eaf4672ecb8d22fb4da","60":"be63bb4a58ddc33938f2","61":"01c38f57087f3221fc70","64":"298c948558bd280ea070"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"0cbcc34d3992db1f1e9978a63f77b32dcd621e3e","2":"bc6035d46d23e0c06a88d56fa29fdfd7a70c7002","3":"c932766d22752000d29a29d23861cc8054401098","4":"455a435357834a04c481392675faa64f6a3b9def","5":"1bfc9850","6":"8870da3999d8eb29c75fcb7ecd61f169a530b4c2","7":"6cad00992574e4b4ecb79bb8db3cc49b1988bbbd","8":"14e68cb6bd6245bc062c636b270e29f1b65ed98c","9":"0c428ae2","10":"69cf29f6a642f418953be3f9f3f996ec8951e346","11":"e7baecb53e83f0d850c8b32fd82c1fc3811beb2d","12":"5f656039bfe7158df1011809f2a764d19aad7bce","13":"ad0fdebf47648f82048db7e5e5e5747c8188ac38","14":"50c5772473374fcd32a37fa3ce46f4808a925965","15":"89408303e9f5343d28e0baae1cbd2bfe8f866606","16":"fde2f15fc409f50db205465780643950249621e7","17":"37c513a04e2ce50c8086637e4b85d9a30e23a1b9","18":"400789b889322af0c58892d25b6fc35d6a17b3bd","19":"6fd3b0ff51b6814cd82eb1e7fdaf6b9a0a6006a4","21":"2c386607","23":"component---src-pages-404-jsx","24":"component---src-pages-about-us-jsx","25":"component---src-pages-billing-jsx","26":"component---src-pages-build-phases-jsx","27":"component---src-pages-build-process-jsx","28":"component---src-pages-case-study-jsx","29":"component---src-pages-contact-us-jsx","30":"component---src-pages-copyright-jsx","31":"component---src-pages-cost-to-make-an-app-[id]-jsx","32":"component---src-pages-cost-to-make-an-app-course-1-jsx","33":"component---src-pages-cost-to-make-an-app-course-2-jsx","34":"component---src-pages-cost-to-make-an-app-dev-steps-jsx","35":"component---src-pages-cost-to-make-an-app-direct-cost-jsx","36":"component---src-pages-cost-to-make-an-app-estimate-jsx","37":"component---src-pages-cost-to-make-an-app-estimation-jsx","38":"component---src-pages-cost-to-make-an-app-expert-consult-jsx","39":"component---src-pages-cost-to-make-an-app-index-jsx","40":"component---src-pages-cost-to-make-an-app-intro-jsx","41":"component---src-pages-cost-to-make-an-app-more-jsx","42":"component---src-pages-cost-to-make-an-app-new-thank-you-jsx","43":"component---src-pages-cost-to-make-an-app-patch-jsx","44":"component---src-pages-cost-to-make-an-app-platforms-jsx","45":"component---src-pages-cost-to-make-an-app-product-marketing-jsx","46":"component---src-pages-cost-to-make-an-app-samples-jsx","47":"component---src-pages-cost-to-make-an-app-sign-up-jsx","48":"component---src-pages-cost-to-make-an-app-testimonial-sign-up-jsx","49":"component---src-pages-cost-to-make-an-app-thank-you-jsx","50":"component---src-pages-cost-to-make-an-app-zero-jsx","51":"component---src-pages-funding-jsx","52":"component---src-pages-index-jsx","53":"component---src-pages-jobs-jsx","54":"component---src-pages-payments-jsx","55":"component---src-pages-privacy-policy-jsx","56":"component---src-pages-sample-apps-jsx","57":"component---src-pages-terms-of-service-jsx","58":"component---src-pages-testimonials-2-jsx","59":"component---src-pages-testimonials-jsx","60":"component---src-pages-thank-you-jsx","61":"component---src-pages-unsubscribe-jsx"}[chunkId]||chunkId) + "." + {"0":"06b9b4b25156a64c2a86","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
